/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeaturesConfigModule, I18nModule } from '@spartacus/core';
import { ProductImageZoomTriggerComponent } from '@spartacus/product/image-zoom/components';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-image-zoom-trigger',
  templateUrl: 'product-image-zoom-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [I18nModule, IconModule, FeaturesConfigModule],
})
export class CustomProductImageZoomTriggerComponent extends ProductImageZoomTriggerComponent {}
